import { infiniteQueryOptions } from '@tanstack/react-query';
import { listInvoices } from '@packages/api/endpoints/invoice.js';
import type { InvoiceListFilterParams } from '@packages/api/endpoints/invoice-list-export.js';
import { queryKeys, getNextPageParam, DEFAULT_LIST_PAGE_SIZE } from '@packages/api';

/**
 * What the invoices page opens on with no filter in the URL. React Query drops
 * `undefined` members when it hashes a key, so this matches the all-undefined
 * object `useInvoiceListFilters` builds.
 */
export const DEFAULT_INVOICE_LIST_FILTERS: InvoiceListFilterParams = {};

export function invoiceListQueryOptions(accountId: string, listFilters: InvoiceListFilterParams) {
  return infiniteQueryOptions({
    queryKey: [...queryKeys.invoices(accountId), listFilters],
    queryFn: ({ pageParam }) => listInvoices(accountId, {
      ...listFilters,
      cursor: pageParam,
      limit: DEFAULT_LIST_PAGE_SIZE,
    }),
    getNextPageParam,
    initialPageParam: undefined as string | undefined,
  });
}
